import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import StageAppResource from "./StageAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import axios from "axios";

class FolderAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'folder';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'folders';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'parentUuid',
            'userUuid',
            'workspaceUuid',
            'stageUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            parent: FolderAppResource,
            user: UserAppResource,
            workspace: WorkspaceAppResource,
            stage: StageAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
            workspace: 'workspace_uuid',
            stage: 'stage_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: {
                    message: "^Folder name can't be blank."
                },
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort: "^Folder name can't be blank."
                },
            },
            parentUuid: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
            },
            workspaceUuid: {
                type: 'string',
            },
            stageUuid: {
                type: 'string',
            },
        };
    }

    async download() {
        const url = this.apiPaths().download.replace('{uuid}', this.uuid);
        const response = await axios.post(url);
        return response;
    }

    apiPaths() {
        return {
            'download': Engine.apiUrl(this.appResourceApiPrefix()) + '/{uuid}/download',
            ...super.apiPaths(),
        }
    }

}

export default FolderAppResource;
